import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: { isExpired: false },
  reducers: {
    setExpired: (state, action: PayloadAction<boolean>) => {
      state.isExpired = action.payload;
    },
  },
});

export const { setExpired } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;